import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

import { ReactComponent as JKLogo } from "_assets/images/jk.svg";

import Login from "./Login";

const Auth = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        px: 2,
        py: 6,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          px: { xs: 3, sm: 5 },
          py: { xs: 4, sm: 5 },
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Box
            sx={{
              "& svg": { height: 44, width: "auto" },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <JKLogo />
          </Box>

          <Chip label="Master Dashboard" color="primary" variant="outlined" />

          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Welcome back
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Sign in to continue to the master dashboard
            </Typography>
          </Box>

          <Login />
        </Stack>
      </Card>
    </Box>
  );
};

export default Auth;
